import { StyleSheet } from "react-native"
import { typography } from "theme"

export const style = StyleSheet.create({
  newBadgeText: {
    fontFamily: typography.primary.normal,
    fontSize: 25,
    fontWeight: "bold",
    position: "absolute",
    right: -5,
    top: 15,
    zIndex: 1,
  },
})
